function setPlatName (platName) {
  if (platName) {
    document.title = platName
  }
}

const profile = {
  state: {
    name: '',
    legend: '',
    logo: '',
    banner: ''
  },
  mutations: {
    setProfile (state, {name, legend, logo, banner}) {
      state.name = name
      state.legend = legend
      state.logo = logo
      state.banner = banner
      setPlatName(legend)
    }
  }
}

export default profile
